import { Box } from '@mui/material';
import unauthorized from 'assets/403.png';

export function Unauthorized() {
  return (
    <Box
      sx={{
        background: `url(${unauthorized}) no-repeat center center fixed`,
        backgroundSize: 'cover',
        height: `calc(100vh - 60px)`,
        marginTop: '-30px',
        marginLeft: '-24px',
        marginRight: '-24px',
      }}
    ></Box>
  );
}
